import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
// import { Password } from "primereact/password";
import { Checkbox } from "primereact/checkbox";
import React, { useEffect } from "react";
import * as Fa from "react-icons/fa";
import {
    createAPIEndpntAddEInvoice,
    Endpoint,
} from "../../../Services/AddEInvoice/AddEInvoiceService";
import storage from "../../../Services/Storage";
import { useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../../Components/Loader";
import Axios from "../../../api/Axios";

const AddEInvoicingItem = () => {
    const auth = storage.getLocal("user");
    const [irpUserId, setIrpUserId] = useState();
    const [irpUserPwd, setIrpUserPwd] = useState();
    const [upidataAll, setUpidataAll] = useState([]);
    const [chkEInvoice, setChkEInvoice] = useState(false);
    const [loader, setLoader] = useState(false);
    const [checked, setChecked] = useState(false);
    const SaveEInvoice = async () => {
        if (irpUserId.trim().length == 0) {
            toast.warn("IRP User ID cannot be blank", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 5000,
            });
            return;
        }
        if (irpUserPwd.trim().length == 0) {
            toast.warn("IRP User password cannot be blank", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 5000,
            });
            return;
        }
        try {
            setLoader(true);
            let obj = {
                irpUserId: irpUserId,
                irpUserPassword: irpUserPwd,
                gstin: auth.EInvGSTNO,
                chkEInvoicing: chkEInvoice,
                chkB2CPaymentQR: upidataAll.B2C_QR == "Y" ? true : false,
                isPQR: false,
                upiId: upidataAll.PAYMENT_UPI_ID,
                compID: auth.CompId,
                strLoginUserId: auth.UserId,
            };
            const res = await createAPIEndpntAddEInvoice().post(
                `${Endpoint.SaveInvoice}`,
                JSON.stringify(obj)
            );
            toast.success(`${res.data.Message}`, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 5000,
            });
            let dataString = localStorage.getItem("status");
            if (dataString) {
                let dataObj = JSON.parse(dataString);
                console.log(dataObj);
                if (dataObj.Data) {
                    dataObj.Data.EInvIRPUserId = irpUserId;
                    dataObj.Data.EInvIRPUserPassword = irpUserPwd;
                }
                localStorage.setItem("status", JSON.stringify(dataObj));
            } else {
                console.log("No data found in localStorage with that key");
            }
        } catch (ex) {
            toast.error(ex?.response?.data?.Message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 5000,
            });
        } finally {
            setLoader(false);
        }
    };
    useEffect(() => {
        let onpageload = async () => {
            try {
                let url = "ParameterSettings/GetEInvoiceItem?";
                let res = await Axios.get(`${url}compid=${auth.CompId}`);
                if (res?.data?.Data?.length > 0) {
                    setUpidataAll(res?.data?.Data);
                    setIrpUserId(res?.data?.Data[0].IRP_USER_ID);
                    setIrpUserPwd(res?.data?.Data[0].IRP_PASSWORD);
                    if (res?.data?.Data[0].E_INVOICING == "Y") {
                        setChkEInvoice(true);
                    } else {
                        setChkEInvoice(false);
                    }
                    if (res?.data?.Data[0].SELF_DECLARATION == "Y") {
                        setChecked(true);
                    } else {
                        setChecked(false);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        };

        onpageload();
    }, []);

    const clickEnble = async () => {
        try {
            let url = "ParameterSettings/UpdateSelfDeclaration?";
            let res = await Axios.get(
                `${url}strSelfDeclaration=Y&compID=${auth.CompId}&UserId=${auth.UserId}`
            );
            console.log(res?.data?.Message);
            toast.success("Records save successfully", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Add E-Invoicing Items</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12"></div>
                </div>
                <section className="sales-box">
                    <div className="row d-flex justify-content-center align-items-center">
                        <div className="col-lg-5 col-md-12 col-sm-12">
                            <form>
                                <div className="d-block mb-2">
                                    <label className="form-label">
                                        E-Invoicing <span className="mandatory">*</span>
                                    </label>
                                    <InputSwitch
                                        checked={chkEInvoice}
                                        onChange={(e) => setChkEInvoice(e.value)}
                                        className="switch-pos ms-2"
                                        required
                                        disabled={chkEInvoice}
                                    />
                                </div>
                                <div className="d-block mb-3">
                                    <label className="form-label">
                                        IRP User ID <span className="mandatory">*</span>
                                    </label>
                                    <InputText
                                        value={irpUserId}
                                        onChange={(e) => setIrpUserId(e.target.value)}
                                        className="form-control"
                                        required
                                    />
                                </div>
                                <div className="d-block mb-3">
                                    <label className="form-label">
                                        IRP User Password <span className="mandatory">*</span>
                                    </label>
                                    <InputText
                                        value={irpUserPwd}
                                        onChange={(e) => setIrpUserPwd(e.target.value)}
                                        required
                                        className="d-block"
                                        toggleMask
                                    />
                                </div>
                                <div className="d-block mt-4">
                                    <div className="text-end">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={() => SaveEInvoice()}

                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-lg-7 col-md-12 col-sm-12">
                            <div className="text-end">
                                <img
                                    src={require("../../../Assets/Images/receipt.png")}
                                    className="w-50"
                                />
                            </div>
                        </div>
                    </div>
                </section>
                {loader ? (
                    <>
                        <Loader />
                    </>
                ) : null}

                <section>
                    <div className="row">
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <div className="sales-box">
                                <div className="row d-flex justify-content-start align-items-start dashed-brdr-bottom mb-3">
                                    <div className="col-2 pt-1">
                                        <Checkbox
                                            onChange={(e) => setChecked(e.checked)}
                                            checked={checked}
                                            disabled={checked}
                                        ></Checkbox>
                                    </div>
                                    <div className="col-10 ps-0">
                                        <label className="form-label text-justify">
                                            My AATO will be greater than or equal to INR 100 crores. Hence,
                                            I opt to complete my E-Invoicing within 30 days of invoice
                                            generation to avoid applicable penalties. My E-invoicing will be
                                            disabled after 30 days of invoice generation.
                                        </label>
                                    </div>
                                </div>

                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="text-end mt-3">
                                        <button
                                            type="button"
                                            title="Click to Enable"
                                            className="btn btn-primary"
                                            disabled={!checked}
                                            onClick={clickEnble}
                                        >
                                            Click to Enable
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-12 col-sm-12">
                            <div className="card">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <h6><Fa.FaCheck className="me-2" /> What needs to be done</h6>
                                    <ul className="additem">
                                        <li>
                                    The E-invoicing should be done within 30 days from the Invoice
                                    Date.
                                        </li>
                                        <li>
                                    You need to be sure that your E-invoicing is not lacking IRN
                                    and signed QR code.{" "}
                                        </li>
                                    </ul>
                                    <h6><Fa.FaCheck className="me-2" /> According to GST Network&apos;s advisory</h6>
                                    <ul className="additem">
                                        <li>
                                    On incorrect invoicing - Rs. 25,000 per invoice (For lack of
                                    IRN and signed QR code)
                                        </li>
                                        <li>
                                    On non-generation of E-Invoice - 100% of the tax due or
                                    Rs.10,000 whichever is higher, for every invoice.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default AddEInvoicingItem;
